import React from 'react';
import EmDestaque from './EmDestaque';
import MaisLidas from './MaisLidas';
import NaveguePorTemas from './NaveguePorTemas';

interface NewsSidebarProps {
  /** Token da unidade de origem da notícia aberta. */
  unidade?: string;
}

/**
 * Coluna lateral da notícia (4/12 no desktop, empilhada no mobile).
 */
export const NewsSidebar: React.FC<NewsSidebarProps> = ({ unidade }) => (
  <aside
    className="mpf-news__sidebar mpf-news-sidebar"
    aria-label="Mais no MPF"
  >
    <EmDestaque />
    <MaisLidas unidade={unidade} />
    <NaveguePorTemas />
  </aside>
);

export default NewsSidebar;
